export default __webpack_public_path__ + "static/media/YOO.01bfd32f.mp3";